var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.75,
    height: 96.744,
    viewBox: "0 0 96.75 96.744",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3acce1;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M56.446,101.244c-2.676,0-4.642-.842-5.537-2.372s-.664-3.657.647-5.99L94.125,8.041C95.4,5.779,97.052,4.5,98.748,4.5S102.1,5.779,103.4,8.1l42.506,84.721c1.344,2.392,1.574,4.519.68,6.049s-2.861,2.373-5.538,2.373Zm-1.823-4.481h88.249L98.748,8.821Zm44.126-7.976a4.772,4.772,0,1,1,4.771-4.773A4.777,4.777,0,0,1,98.748,88.788Zm0-18.686a4.777,4.777,0,0,1-4.772-4.772V46.644a4.771,4.771,0,1,1,9.542,0V65.33A4.776,4.776,0,0,1,98.749,70.1Z",
    transform: "translate(-50.372 -4.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.e67bfd50bccc229fedb030d03d1ef381.svg";
export { ForwardRef as ReactComponent };